export const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  cookieName: import.meta.env.VITE_COOKIE_NAME,
  portalUrl: import.meta.env.VITE_PORTAL_URL,
  customUrlProtocol: import.meta.env.VITE_CUSTOM_URL_PROTOCOL,
  sso: {
    microsoftClientId: import.meta.env.VITE_SSO_MICROSOFT_CLIENT_ID,
    microsoftAuthority: import.meta.env.VITE_SSO_MICROSOFT_AUTHORITY || 'https://login.microsoftonline.com/common',
    googleClientId: import.meta.env.VITE_SSO_GOOGLE_CLIENT_ID,
    appleClientId: import.meta.env.VITE_SSO_APPLE_CLIENT_ID,
    redirectUri: import.meta.env.VITE_SSO_REDIRECT_URI,
  },
  serviceDeskUrl: 'https://singularhealth.atlassian.net/servicedesk/customer/portal/68/group/72/create/226',
  knowledgeBaseUrl: 'https://3dicomviewer.com/knowledgebase',
};
